import React from 'react';
import { Layout, Typography, Space, Breadcrumb } from 'antd';
import { HomeOutlined, UserOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';

const { Header: AntHeader } = Layout;
const { Title } = Typography;

const Header = ({ pageTitle }) => {
  const location = useLocation();

  const getBreadcrumbItems = () => {
    const path = location.pathname;
    const items = [
      {
        title: <HomeOutlined />,
        href: '/',
      }
    ];

    if (path === '/') {
      items.push({
        title: 'Dashboard',
      });
    } else if (path === '/clients') {
      items.push({
        title: 'Clients',
      });
    } else if (path === '/users') {
      items.push({
        title: 'Users',
      });
    } else if (path === '/settings') {
      items.push({
        title: 'Settings',
      });
    }

    return items;
  };

  return (
    <AntHeader style={{ 
      background: '#fff', 
      padding: '0 24px', 
      display: 'flex', 
      flexDirection: 'column',
      justifyContent: 'center',
      minHeight: '64px',
      boxShadow: '0 1px 4px rgba(0,21,41,.08)'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>
          <Title level={3} style={{ margin: 0 }}>
            {pageTitle || 'Dashboard'}
          </Title>
          <Breadcrumb 
            items={getBreadcrumbItems()}
            style={{ marginTop: '4px' }}
          />
        </div>
        <div>
          <Space>
            {/* <span style={{ color: '#666', fontSize: '14px' }}>
              Welcome back!
            </span> */}
          </Space>
        </div>
      </div>
    </AntHeader>
  );
};

export default Header;
